import React from "react";
import { HiOutlineTicket } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneTheater } from "../../../lib/sysNavigation/SysNavigation";

type TheaterRow = {
  theater_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<TheaterRow>
    type={_TYPES_.THEATER}
    title="Theaters"
    subtitle="Theaters featured on the public site."
    icon={<HiOutlineTicket className="h-5 w-5" />}
    addRoute="/data/theater/add"
    editRoute="/data/theater/edit"
    pushOne={pushOneTheater}
    dataKey="theaters"
    countKey="theatersCount"
    idField="theater_id"
  />
);

export default Overview;
